import { ThemeProvider } from "@/components/theme/themeProvider"
import { App } from "@/webApp"
import { Config } from "@modules/config"
import { appQueryClient } from "@modules/core/api/queryClient"
import { ServicesContextProvider } from "@modules/core/services/services.context"
import * as Sentry from "@sentry/react"
import { QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { createRoot } from "react-dom/client"
import { scan } from "react-scan"

if (Config.ENV === "prod") {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  console.log = () => {}
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  console.info = () => {}
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  console.warn = () => {}
}
const env = Config.ENV
if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: Config.SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    environment: Config.SENTRY_ENV,
    tracesSampleRate: env === "prod" ? 0.25 : 1.0,
    release: `${__VERSION__}-${__GIT_HASH__}-${env}`,
    beforeSend(event) {
      const message = (event.message ?? "").toLowerCase()
      const exception = (event.exception?.values?.[0]?.value ?? "").toLowerCase()
      const combined = `${message} ${exception}`

      if (/networkerror|err_network|econnrefused|econnreset|failed to fetch|load failed/i.test(combined)) return null
      if (/aborterror/i.test(combined)) return null
      if (/chunkloaderror|loading chunk \d+ failed|loading css chunk/i.test(combined)) return null
      if (/resizeobserver|script error\.?$/i.test(combined)) return null
      if (/chrome-extension:|moz-extension:|safari-extension:/i.test(combined)) return null
      // ProseMirror's clipboard handler uses trustedTypes.defaultPolicy when available.
      // A browser extension or corporate policy can create that policy without createHTML,
      // making ProseMirror throw. We can't override the default policy from app code.
      if (/trustedtypepolicy.*createhtml|createhtml.*trustedtypepolicy/i.test(combined)) return null

      return event
    },
  })
}
if (import.meta.env.DEV) {
  scan({
    enabled: true,
  })
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(document.getElementById("root")!)
root.render(
  /* <React.StrictMode>*/
  <QueryClientProvider client={appQueryClient}>
    <ServicesContextProvider>
      <ThemeProvider>
        <App />
      </ThemeProvider>
      {Config.ENV === "dev" && <ReactQueryDevtools initialIsOpen={false} />}
    </ServicesContextProvider>
  </QueryClientProvider>,
  /*  </React.StrictMode>,*/
)
